import Plyr from 'plyr';

export function video() {
  // eslint-disable-next-line
  const players = Array.from(document.querySelectorAll('.plyr-video')).map(p => new Plyr(p,{
    controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
  }));

  if(players.length > 0){
    $.each(players, function(index, element){
      element.on('playing', (event) => {
        const instance = event.detail.plyr;

        window.dataLayer.push({
          'event': 'video_playing',
          'video_source': instance.media.currentSrc,
        });
      });
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/video.js